import axios from 'axios'
//import { fnObj } from '../data/returnObj'

const callApi = async (method, url, body, headers) => {
    return new Promise(async (resolve, reject) => {
        if (!headers) headers = {}
        headers["Authorization"] = `Bearer ${localStorage.getItem("actk")}`
        const config = {
            method,
            url,
            headers
        }
        if (body) config["data"] = body
        axios(config)
            .then(response => {
                // fnObj.status = response.status
                // fnObj.data = response.data.data
                // fnObj.msg = response.data.data.msg
                // fnObj.statusCode = "000"
                resolve(response.data)
            }).catch((error) => {
                // fnObj.statusCode = "001"
                // fnObj.status = error.status
                // fnObj.msg = `[${error.status}] Catch Error: ${error}`
                // fnObj.data = error
                // if (error.response) {
                //     fnObj.statusCode = "002"
                //     fnObj.status = error.response.status
                //     fnObj.msg = `[${error.response.status}] Catch Error: ${error.response.data.msg}`
                //     fnObj.data = error.response.data
                // }
                reject(error)
            })
    })
}

export default callApi